import React from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H4, H5, P } from '../../../AbstractElements';
import Alerts from '../../../CommonElements/Alert';
import { AdditionalContent, Additionaltext, Aditionalpara, Aditionalpara2, Welldone } from '../../../Constant';

const AdditionalContents = () => {
  return (
    <Col sm='12'>
      <Card>
        <CardHeader className='pb-0'>
          <H5>{AdditionalContent}</H5>
          <span>{Additionaltext}</span>
        </CardHeader>
        <CardBody className='card-body'>
          <Alerts color='primary '>
            <H4 className='alert-heading'>{Welldone}</H4>
            <P>{Aditionalpara}</P>
            <hr />
            <P className='mb-0'>{Aditionalpara2}</P>
          </Alerts>
          <Alerts color='secondary'>
            <H4 className='alert-heading'>{Welldone}</H4>
            <P>{Aditionalpara}</P>
            <hr />
            <P className='mb-0'>{Aditionalpara2}</P>
          </Alerts>
          <Alerts color='success'>
            <H4 className='alert-heading'>{Welldone}</H4>
            <P>{Aditionalpara}</P>
            <hr />
            <P className='mb-0'>{Aditionalpara2}</P>
          </Alerts>
          <Alerts color='danger'>
            <H4 className='alert-heading'>{Welldone}</H4>
            <P>{Aditionalpara}</P>
            <hr />
            <P className='mb-0'>{Aditionalpara2}</P>
          </Alerts>
          <Alerts color='info'>
            <H4 className='alert-heading'>{Welldone}</H4>
            <P>{Aditionalpara}</P>
            <hr />
            <P className='mb-0'>{Aditionalpara2}</P>
          </Alerts>
          <Alerts color='light'>
            <H4 className='alert-heading'>{Welldone}</H4>
            <P>{Aditionalpara}</P>
            <hr />
            <P className='mb-0'>{Aditionalpara2}</P>
          </Alerts>
          <Alerts color='dark'>
            <H4 className='alert-heading'>{Welldone}</H4>
            <P>{Aditionalpara}</P>
            <hr />
            <P className='mb-0'>{Aditionalpara2}</P>
          </Alerts>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AdditionalContents;
